var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ expanded: _vm.expanded, single: _vm.single },on:{"click":function($event){return _vm.$emit('toggle', !_vm.expanded)}}},[_c('Icon',{attrs:{"name":_vm.single ? 'angle-down' : 'expand',"pointer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }